import { render, staticRenderFns } from "./systemConfiguration.vue?vue&type=template&id=c824fc16&scoped=true&"
import script from "./systemConfiguration.vue?vue&type=script&lang=js&"
export * from "./systemConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c824fc16",
  null
  
)

export default component.exports